// @flow weak

import { appConfig } from "../../config";
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
} from "../fetchTools";

export const getUserInfoData = () => {
  const url = `${getLocationOrigin()}/${appConfig.userInfos.data.API}`;
  const options = { ...defaultOptions };

  fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};

export const logout = (postData, key) => {
  const url = `${getLocationOrigin()}/${appConfig.userInfos.data.API}`;
  fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      secretkey: key,
      Authorization: postData
    },
    // body: JSON.stringify()
  })
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};


// WEBPACK FOOTER //
// ./src/app/services/API/userInfos.js